<template>
  <div>
    <!-- <div class="header_load" :class="classNames" v-if="pcShow"> -->
    <div class="header_load" :class="classNames" >
      <el-row>
        <el-col :span="1" class="header_block"></el-col>
        <el-col :span="22" class="header_block">
          <img ref="logoPC" class="logoPC" :src="logoArray[logoIndex].url" alt="企业宣传片拍摄" />
          <div class="menu"> 
            <div
              ref="menuDivs"
              v-for="(item,index) in titleArray"
              :key="index"
              :class="Number(indexInit)===Number(index)?`${menuClassNames} active`: menuClassNames"
              @click="jumpEachPage(item)"
            >{{item.text}}</div>
          </div>
        </el-col>
        <el-col :span="1" class="header_block"></el-col>
      </el-row>
    </div>
    <!-- <div class="header_load_mobile" v-if="!pcShow">1111</div> -->
  </div>
</template>

<script>
export default {
  name: "headerTitle",
  props: {
    indexInit: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      titleArray: [
        { text: "首页", url: "home" },
        { text: "直播", url: "shootvideo" },
        { text: "短视频", url: "shortvideo" },
        // { text: "服务项目", url: "business" },
        { text: "商业视频", url: "bussvideo" },
        { text: "视频课程", url: "videocourse" },
        { text: "多媒体展示", url: "multimedia" },
        { text: "案例展示", url: "casepage" },
        { text: "关于我们", url: "aboutus" }
      ],
      logoArray: [
        { url: require("@/assets/imgs/logo.png") },
        { url: require("@/assets/imgs/logo-active.png") }
      ],
      logoIndex: 0,
      classNames: "",
      menuClassNames: "menu_each",
      // pcShow: true
    };
  },
  mounted() {
    // this.widthChange();
    window.addEventListener("scroll", this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    // window.addEventListener("resize", this.widthChange);
  },
  methods: {
    // widthChange() {
    //   let clientWidthW = document.body.clientWidth;
    //   if (clientWidthW < 768) {
    //     this.pcShow = false;
    //   } else {
    //     this.pcShow = true;
    //   }
    // },
    handleScroll() {
      this.$nextTick(() => {
        let scrollTop =
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageYOffset;
        if (scrollTop > 60) {
          this.logoIndex = 1;
          this.classNames = "nav_bg_white_add";
          this.menuClassNames = "menu_each each_toggle";
        } else {
          if (this.classNames === "nav_bg_white_add") {
            this.classNames = "nav_bg_white_reduce";
          }
          this.logoIndex = 0;

          this.menuClassNames = "menu_each ";
        }
      });
    },
    jumpEachPage(item) {
      document.documentElement.scrollTop = 0;
      this.$router.push({
        name: item.url
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.header_load {
  width: 100%;
  height: 69px;
  position: fixed;
  z-index: 10000;

  .header_block {
    height: 69px;
  }
  .logoPC {
    float: left;
    // width: 143px;
    // height: 59px;
    // margin-top: 5px;
  }
  .menu {
    height: 69px;
    float: right;
    display: flex;
    align-items: center;
    .menu_each {
      width: 100px;
      height: 40px;
      color: #fff;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
      font-size: 16px;
      margin-right: 12px;
    }
    .each_toggle {
      color: #000;
    }
    .menu_each:hover {
      background: #e91d62;
      color: #fff;
    }
    .active {
      color: #fff;
      background: #e91d62;
    }
  }
}

.nav_bg_white_add {
  -webkit-animation: nav-ann-add 1s linear 1;
  animation: nav-ann-add 1s linear 1;
  background-color: #f6f6f8;
  border-bottom: 1px #d8dbe2 solid;
  height: 76px;
}

.nav_bg_white_reduce {
  -webkit-animation: nav-ann-reduce 0.5s linear 1;
  animation: nav-ann-reduce 0.5s linear 1;
  height: 0px;
}

/* 导航动画 */

@-webkit-keyframes nav-ann-add {
  0% {
    /* opacity: 0; */
    background-color: #f6f6f8;
    border-bottom: 1px #d8dbe2 solid;
    height: 0px;
  }
  100% {
    /* opacity: 1; */
    background-color: #f6f6f8;
    height: 76px;
    border-bottom: 1px #d8dbe2 solid;
  }
}

@keyframes nav-ann-add {
  0% {
    /* opacity: 0; */
    background-color: #f6f6f8;
    border-bottom: 1px #d8dbe2 solid;
    height: 0px;
  }
  100% {
    /* opacity: 1; */
    background-color: #f6f6f8;
    height: 76px;
    border-bottom: 1px #d8dbe2 solid;
  }
}

@-webkit-keyframes nav-ann-reduce {
  0% {
    background-color: white;
    border-bottom: 1px #d8dbe2 solid;
    height: 76px;
  }
  100% {
    background-color: white;
    height: 0px;
    border-bottom: 1px #d8dbe2 solid;
  }
}

@keyframes nav-ann-reduce {
  0% {
    background-color: white;
    border-bottom: 1px #d8dbe2 solid;
    height: 76px;
  }
  100% {
    background-color: white;
    height: 0px;
    border-bottom: 1px #d8dbe2 solid;
  }
}
</style>



